import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../karoltruculoarq/karoltruculoarq.module.scss';
import top from '../karoltruculoarq/src/top.png';
import bottom from '../karoltruculoarq/src/bottom.png';
import imgWhatsapp from '../karoltruculoarq/src/1.png';
import imgMaps from '../karoltruculoarq/src/2.png';
import imgInstagram from '../karoltruculoarq/src/3.png';
import imgServicos from '../karoltruculoarq/src/4.png';

const Karoltruculoarq: React.FC = () => {
    const icons = [
        { src: imgWhatsapp, alt: "WHATSAPP", label: "WHATSAPP", link: "https://wa.me/5517981304321?text=Olá! vim pelo link na bio e gostaria de mais informações...", linkInterno: false },
        { src: imgMaps, alt: "LOCALIZAÇÃO", label: "LOCALIZAÇÃO", link: "https://maps.app.goo.gl/Wsn1CCY3ZQfi2LSL9", linkInterno: false },
        { src: imgInstagram, alt: "INSTAGRAM", label: "INSTAGRAM", link: "https://www.instagram.com/karoltruculoarq?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==", linkInterno: false },
        { src: imgServicos, alt: "PORTIFÓLIO", label: "PORTIFÓLIO", link: "/karoltruculoarq/servicos", linkInterno: true },
    ];

    return (
        <div className={styles.karoltruculoarq}>
            {/* Imagem do topo */}
            <img src={top} alt="Topo" className={styles.topImage} />

            {/* Seção de ícones */}
            <div className={styles.iconSection}>
                <div className={styles.iconsContainer}>
                    {icons.map((icon, index) => (
                        <div className={styles.iconItem} key={index}>
                            {icon.linkInterno ? (
                                <Link to={icon.link} className={styles.iconLink}>
                                    <img src={icon.src} alt={icon.alt} className={styles.iconImage} />
                                    <p className={styles.iconLabel}>{icon.label}</p>
                                </Link>
                            ) : (
                                <a
                                    href={icon.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={styles.iconLink}
                                >
                                    <img src={icon.src} alt={icon.alt} className={styles.iconImage} />
                                    <p className={styles.iconLabel}>{icon.label}</p>
                                </a>
                            )}
                        </div>
                    ))}
                </div>
            </div>

            {/* Imagem de baixo */}
            <img src={bottom} alt="Rodapé" className={styles.bottomImage} />
        </div>
    );
};

export default Karoltruculoarq;
